export const BASE_PATH_TO_CORPORATE_CHALLENGES = "/corporate-challenges";

export const BASE_PATH_TO_REGISTER = `${BASE_PATH_TO_CORPORATE_CHALLENGES}/register`;
export const BASE_PATH_TO_COMBINED_LEADERBOARD = `${BASE_PATH_TO_CORPORATE_CHALLENGES}/combined-leaderboard`;
export const BASE_PATH_TO_ALL_LEADERBOARDS = `${BASE_PATH_TO_CORPORATE_CHALLENGES}/all-leaderboards`;
export const BASE_PATH_TO_CHALLENGE_PARTICIPANTS = `${BASE_PATH_TO_CORPORATE_CHALLENGES}/participants`;
export const BASE_PATH_TO_LEADERBOARD = `${BASE_PATH_TO_CORPORATE_CHALLENGES}/leaderboard`;
